<template>
  <div>
    <div class="c_content">
      <div class="c_banner">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(items,index) in collectionType" v-on:click="update(items.id,index)">
              <span >{{items.shortname}}</span>
              <div :class="index==current?'cur':''"></div>
            </div>
          </div>
        </div>
      <!--  <swiper :options="swiperOption">
          <swiper-slide v-for="(items,index) in collectionType" v-on:click="update(item.id,index)">
            <span :class="index==current?'cur':''">{{items.name}}</span>
          </swiper-slide>
        </swiper>-->
      </div>
      <div class="c_search">

        <div class="c_skey">
          <input type="text" v-model="keyword" @keyup.enter="getCollectionss(false)">
          <img src="static/images/searchbtn.svg" alt="" v-on:click="getCollectionss(false)">
        </div>
      </div>

      <div class="collectList" v-if="collectionList" v-show="dataFlag">
        <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
          <li @click="gotodetail(item.id)"  v-for="item in collectionList" class="collectItem"><img :src="item.imageUrl" v-if='item.imageUrl' alt="" /><div class="iteminfo"><span class="mumName">{{item.name}}</span><span class="mumAdress">{{item.detailAddress}}</span></div>
            <div class="loc-box" style="display:none;">
              <img src="../assets/loc.svg" alt="">
              <label>{{item.distance}}</label>
            </div>
          </li>
        </ul>
      </div>
      <noData  v-if="!dataFlag"></noData>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {api} from '../global/api';
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  import { Indicator } from 'mint-ui';
  import noData from './noData';
  export default {
    data(){
      return {
        latitude: '',
        longitude: '',
        collectionList:[],
        collectionType:[{"shortname":"全部","id":""}],
        loading:true,
        current:0,
        keyword:"",
        mySwiper:{},
        areaId:"",
        page:1,
        size:4,
        dataFlag:true
      }
    },
    components: { // 声明子组件
      noData
    },
    mounted(){
      let that=this;
      this.getType();
      this.getLatitude();
      // this.getCollections(false);
      var mySwiper = new Swiper('.swiper-container', {
        loop:false,
        slidesPerView:5.5,
        initialSlide :0,
        spaceBetween:between()/2,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        on: {
          init: function(){
            //Swiper初始化了
           // setTimeout(function(){document.getElementsByClassName("swiper-wrapper")[0].style.transform="translate3d(0px,0px,0px)"},500);
            setTimeout(function(){document.getElementsByClassName("swiper-wrapper")[0].style.transform="translate3d(0px,0px,0px)"},500);
            console.log(1111)
          },
        }

      })
     // that.swiper()
    },
    methods: {
      handleChange(index) {

      },
      getCollectionss(flag){
        this.page=1;
        this.getCollections(flag);
      },
      swiper(){
        this.mySwiper = new Swiper('.swiper-container', {
          loop:false,
          slidesPerView:5.5,
          initialSlide :0,
          spaceBetween:between()/2,
          observer:true,//修改swiper自己或子元素时，自动初始化swiper
          observeParents:true,//修改swiper的父元素时，自动初始化swiper
          onInit: function(swiper){
            //Swiper初始化了
            //alert(swiper.activeIndex);提示Swiper的当前索引
          }
        })
      },
      loadMore() {
        this.page ++;
        this.loading = true;
        this.getCollections(true);

       /* setTimeout(() => {
          this.page ++;
          this.getCollections(true);
        }, 500);*/
      },
      gotodetail(id) {
        this.$router.push({
          path: 'mumDetail',
          query: { id: id }
        });
      },
      getCollections(flag){
        let that = this;
        let params={latitude:this.latitude, longitude:this.longitude,area:this.areaId,name:this.keyword,currentPage:this.page,size:this.size};
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        this.$http.get(api.getMuseumSearchList,{params:params}).then(response  => {
          if(response.data.success==1){
            Indicator.close();
            if(flag){
              that.collectionList = that.collectionList.concat(response.data.data);
              if(response.data.data.length == 0){
                that.loading = true;
              }else{
                that.loading = false;
              }
            }else{
              if(response.data.data.length>0) {
                that.collectionList = response.data.data;
                that.loading = false;
                that.dataFlag=true;
              }else{
                that.dataFlag=false;
                that.loading=true;
              }

              /*this.collectionList = response.data.data;
              this.loading = false;*/
            }
          }else{
            console.log("接口异常");
          }

      }, response => {

        })
      },
      // 获取经纬度
      getLatitude() {
        let vm = this;
        var geolocation = new BMap.Geolocation();
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        // Indicator.open({spinnerType: 'fading-circle'});
        geolocation.getCurrentPosition(function(r){
          Indicator.close();
          if(this.getStatus() == BMAP_STATUS_SUCCESS){
            vm.latitude = r.point.lat;
            vm.longitude = r.point.lng;
            // vm.getData();
            vm.getCollections(false);
          } else {
            console.log('failed'+this.getStatus());
          }        
        }, function() {
          Indicator.close();
        }, {enableHighAccuracy: true});
      },
      getType(){
        let that = this;
        this.$http.get(api.getAreaList).then(response  => {
        that.collectionType = that.collectionType.concat(response.data.data);
         // that.areaId=response.data.data[0].id;
      //  that.swiper()
      }, response => {

        })
      },
      update(id,i){
            this.current=i;
            this.areaId=id;
            this.page=1;
            //this.collectionList=[];
            this.getCollections(false);

      }
    }

  }
</script>

<style scoped="">
  .c_content{
    padding: 0 .75rem;
    position: relative;
  }
  .c_banner{
    height: 2.25rem;
    width: 100%;
  }
  .swiper-slide div.cur{
    width:.8rem;background-color:  rgba(196, 77, 65, 1);
    height: .1rem;
   position: absolute;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
  }
  .c_banner span{
   /* width: 1.6rem;*/
    height: 2.25rem;
    line-height: 2.25rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.8rem;
    text-align: center;
    display: block;
    font-family: PingFang-SC-Bold;
  }
  .c_search{
    width: 100%;
    height: 1.45rem;
    padding: .4rem 0;
    background-color: rgba(255, 255, 255, 1);
  }
  .c_skey input{
    width: 17.25rem;
    height: 1.5rem;
    border-radius: 0.5rem;
    text-indent: 1.5rem;
    border: none;
    background-color: rgba(241, 241, 242, 1);
    font-size: 0.7rem;
  }
  .c_stype,.c_syear,.c_skey{
    display: inline-block;
    position: relative;
  }
  .c_stype{
    width: 2.8rem;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Medium;
  }
  .c_stype i,.c_syear i{
    position: absolute;
    right: .5rem;
    width: 9px;
    height: 5px;
    display: block;
  }
  .c_stype i.down,.c_syear i.down{
    background: url("../../static/images/down.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .c_stype i.up,.c_syear i.up{
    background: url("../../static/images/up.svg") center no-repeat;
    background-size: 100% 100%;
  }
  .c_stype i,.c_syear i,.c_skey img{
    margin: auto;
    top: 0;
    bottom: 0;
  }
  .c_skey img{
    position: absolute;
    left: .5rem;
  }
  .c_syear{
    width: 2.8rem;
    height: 0.7rem;
    line-height: 0.7rem;
    color: rgba(51, 51, 51, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Medium;
  }
  .collectList{
    width: 100%;
    margin-top: .85rem;
    padding-bottom: 2.45rem;
  }
  .collectList ul:after{
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .collectItem{
    position: relative;
    float: left;

    margin-bottom: .5rem;
    position: relative;
  }
  .collectItem .loc-box {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 13px;
  }
  .collectItem .loc-box img {
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: -2px;
    background: transparent;
  }
  .collectItem .loc-box label {
    color: #C44D41;
    width: auto;
  }
  .collectItem img{
    display: block;
    border-radius: 0.5rem;
    width: 17.25rem;
    height: 12.9rem;

    background-color: #FFFFFF;
  }
  .collectItem span{
    display: block;
    width: 15rem;
    text-align: left;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
   /* position: absolute;*/
    left: .75rem;
  }
  .iteminfo{
  // background-color: #666666;
    position: absolute;
  // width: 16.5rem;
  // left: 0.75rem;
  // bottom: 0.5rem;
    width: 16.25rem;
    padding: 0.5rem;
    bottom:0;
    display: block;
    color: rgba(255, 255, 255, 1);
    background: -webkit-linear-gradient(rgba(0,0,0,0),rgba(0,0,0,1));
    background: -moz-linear-gradient(top,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);; /*FireFox*/
    background: -o-linear-gradient(top,rgba(255,255,255,0) 0%,rgba(255,255,255,1) 100%);  /* Opear */
    background: -ms-linear-gradient(rgba(0,0,0,0),rgba(0,0,0,1)); /*IE10及IE10+*/
    background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,1));
  }
  .mumName{
    line-height: 0.95rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.7rem;
    font-family: PingFang-SC-Bold;
    bottom: 1.35rem;
  }
  .mumAdress{
    line-height: 0.65rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.65rem;
    text-align: left;
    font-family: PingFang-SC-Regular;
    bottom: .5rem;
  }
  .total{
    width: 100%;
    height: 2rem;
    background-color: rgba(196, 77, 65, 1);
    text-align: center;
    position: fixed;
    bottom:1.9rem;
    z-index: 10000;
  }
  .total span{
    width: 6.4rem;
    height: 2rem;
    line-height: 2rem;
    color: rgba(255, 255, 255, 1);
    font-size: 0.65rem;
    text-align: left;
    font-family: PingFang-SC-Medium;
  }
  .c_type,.c_year{
    position: absolute;
    top: 4.5rem;
    width: 100%;
    height: 22.7rem;
    background-color: rgba(241, 241, 242, 1);
    z-index: 100;
  }
  .c_type ul:after,.c_year ul:after{
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }
  .c_type ul,.c_year ul{
    padding: 1rem .75rem;
  }
  .c_type li,.c_year li{
    float: left;
    text-align: center;
    height: 1.5rem;
    border-radius: 0.75rem;
    border: 0.05rem solid rgba(153, 153, 153, 1);
    padding: .2rem .4rem;
    margin-right: 1rem;
    margin-bottom: 1rem;
  }
  .c_type span,.c_year span{
    height: 1.5rem;
    line-height:1.5rem;
    color: rgba(153, 153, 153, 1);
    font-size: 0.7rem;
    text-align: left;
    font-family: PingFang-SC-Medium;
  }
</style>



// WEBPACK FOOTER //
// src/view/museum.vue